import "../styles/colors.css";
import "../styles/home.css";

import SEO from "../components/SEO";

import Contactform from "../components/Contactform";

//  import { ReactComponent as SerenityLogo } from "../assets/svgs/Serenityy.svg";
// import React, { useState } from "react";
import useScrollEffects from "../animations/useScrollEffects";

import skyscraper from "../assets/home/skyscrapers_tint.webp";
import logo from "../assets/svgs/Serenityy.svg";
// import sunsetBackground from "../assets/svgs/sunset.svg";
import ourJourneySvg from "../assets/svgs/our-journey-2.svg";
import visionMissionBg from "../assets/svgs/sunset.svg"; // or png
// import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Home() {
  // const navigate = useNavigate();

  // // Function to handle tile click
  // const scrollToService = (serviceIndex) => {
  //   // Navigate to the services page with a hash corresponding to the service index
  //   navigate(`/services#service-${serviceIndex}`);
  // };

  const { backgroundStyles, heroTextVisible, introOpacity, hidderVisible } =
    useScrollEffects();

  // const [stage, setStage] = useState(1);
  const testimonials = [
    {
      quote:
        "Serenityy has guided me through my overall financial planning with great care and attention. Abhishek was extremely professional and implemented effective strategies to help my financial plan stay on track and achieve its goals.",
      name: "Asim Kamdar",
      title: "Proprietor, Sansim INC",
    },
    {
      quote:
        "The process was smooth and well managed by the team. Their attention to detail, timely updates, and clear communication made the entire experience seamless.",
      name: "Arpit Bansal",
      title: "-",
    },
    {
      quote:
        "Serenity took the time to understand my financial goals and created a strategy that made sense for me. Their advice was practical and helped me feel more confident about my future.",
      name: "Ramesh Madhavan Mangalath",
      title: "Senior Procurement Engineer, DAMAC Properties",
    },
  ];

  return (
    <main className="main-section">
      <SEO
        title="Serenityy - From Uncertainty to Financial Serenity"
        description="Serenityy offers innovative financial and marketing solutions to help businesses grow and achieve financial success."
        keywords="Financial Planning, Marketing, Real Estate Advisory, Insurance Solutions, Tax Planning, Low-Risk Investments"
        image="assets/logo.png"
        url="https://www.serenityy.ae"
      />

      {/* Hero Intro section */}
      <section className="hero-intro-section">
        <div className="parallax-wrapper">
          <div className="parallax-background" style={backgroundStyles}>
            <img src={skyscraper} alt="Skyscraper" className="parallax-image" />
            <div
              className="hero-text"
              style={{
                position: heroTextVisible ? "relative" : "",
                opacity: heroTextVisible ? 1 : 0,
                // transform: heroTextVisible ? 'translateY(0)' : 'translateY(-100px)',
                transition: "all 0.4s ease-out",
              }}
            >
              <div className="hero-logo-wrapper">
                {/*<SerenityLogo className="logo" />*/}
                <img
                  src={logo}
                  alt="Serenityy Logo"
                  className="hero-logo"
                ></img>
              </div>
              <div className="hero-tagline-wrapper">
                <p className="hero-tagline">
                  From Uncertainty to Financial Serenity
                </p>
              </div>
            </div>
          </div>

          <div
            className="hider"
            style={{
              opacity: hidderVisible ? 1 : 0,
              transform: hidderVisible ? "translateY(-15vh)" : "translateY(0)",
              transition: "all 0.4s ease-out",
            }}
          ></div>

          <div className="content-overlay">
            <div
              className="intro-text-container"
              style={{
                opacity: introOpacity,
              }}
            >
              <div className="blur-background">
                <p className="section-text">
                  We are a dynamic commercial organization combining the
                  strengths of a <strong>financial company</strong> and a{" "}
                  <strong>marketing management firm</strong>. We operate as a
                  powerful full-service group, offering financial guidance
                  alongside innovative marketing solutions as per your business
                  needs. <br />
                  <br />
                </p>
                <p className="section-text">
                  Whether you're looking to expand your business presence or
                  manage your finances with precision, we’re here to help you
                  grow with confidence. We take the time to understand your
                  goals, crafting strategies that align with your vision while
                  ensuring transparency, reliability, and long-term success.
                  With Serenityy, you gain a trusted partner dedicated to your
                  growth, every step of the way.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise */}
      <section className="expertise-section">
        <h3 className="expertise-subtitle">Our Expertise</h3>
        <div className="expertise-grid">
          {/* Tile 1 */}
          <div className="expertise-item">
            <div className="expertise-content">
              <div className="expertise-text">
                <h3 className="expertise-title">
                  <span className="highlight-bg">
                    Financial Strategy <br />
                    Planning
                  </span>
                </h3>
                <p className="expertise-description">
                  Get tailored strategies to align your finances with
                  long-term personal and business goals.
                </p>

                <div className="learn-more">
                  <div className="circle-icon">
                    <svg viewBox="0 0 24 24" width="26" height="26">
                      <circle cx="12" cy="12" r="12" fill="#000" />
                      <g transform="rotate(135 12 12)">
                        <path
                          fill="#F96E2A"
                          d="M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z"
                        />
                      </g>
                    </svg>
                  </div>
                  <Link
                    to="/services#financial-strategy-planning"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <span className="learn-more-text">Learn more</span>
                  </Link>
                </div>
              </div>
              <div className="icon-wrapper">
                <img
                  src={require("../assets/services/chart_grey.webp")}
                  alt="Financial Strategy Icon"
                  className="tile-icon default"
                />
                <img
                  src={require("../assets/services/chart_color.webp")}
                  alt="Financial Strategy Icon Colored"
                  className="tile-icon hover"
                />
              </div>
            </div>
          </div>

          {/* Tile 2 */}
          <div className="expertise-item">
            <div className="expertise-content">
              <div className="expertise-text">
                <h3 className="expertise-title">
                  <span className="highlight-bg">
                    Real Estate <br />
                    Advisory
                  </span>
                </h3>
                <p className="expertise-description">
                  Expert guidance for smart property investments — from
                  research to final purchase.
                </p>
                <div className="learn-more">
                  <div className="circle-icon">
                    <svg viewBox="0 0 24 24" width="26" height="26">
                      <circle cx="12" cy="12" r="12" fill="#000" />
                      <g transform="rotate(135 12 12)">
                        <path
                          fill="#F96E2A"
                          d="M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z"
                        />
                      </g>
                    </svg>
                  </div>
                  <Link
                    to="/services#real-estate-advisory"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <span className="learn-more-text">Learn more </span>
                  </Link>
                  {" "}
                <a
                  href="https://serenityymaison.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "#F96E2A", marginLeft: "auto" }}
                >
                  🔗 Serenityy Maison ↗
                </a>
                </div>
              </div>
              <div className="icon-wrapper">
                <img
                  src={require("../assets/services/house_grey.webp")}
                  alt="Low Risk Investment Icon"
                  className="tile-icon default"
                />
                <img
                  src={require("../assets/services/house_color.webp")}
                  alt="Low Risk Investment Icon Colored"
                  className="tile-icon hover"
                />
              </div>
            </div>
          </div>

          {/* Tile 3 */}
          <div className="expertise-item">
            <div className="expertise-content">
              <div className="expertise-text">
                <h3 className="expertise-title">
                  <span className="highlight-bg">
                    Insurance & Critical <br />
                    Illness Solutions
                  </span>
                </h3>
                <p className="expertise-description">
                  We offer comprehensive coverage and critical illness
                  protection for unexpected life challenges.
                </p>
                <div className="learn-more">
                  <div className="circle-icon">
                    <svg viewBox="0 0 24 24" width="26" height="26">
                      <circle cx="12" cy="12" r="12" fill="#000" />
                      <g transform="rotate(135 12 12)">
                        <path
                          fill="#F96E2A"
                          d="M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z"
                        />
                      </g>
                    </svg>
                  </div>
                  <Link
                    to="/services#insurance-critical-illness"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <span className="learn-more-text">Learn more</span>
                  </Link>
                </div>
              </div>
              <div className="icon-wrapper">
                <img
                  src={require("../assets/services/heart_grey.webp")}
                  alt="Low Risk Investment Icon"
                  className="tile-icon default"
                />
                <img
                  src={require("../assets/services/heart_color.webp")}
                  alt="Low Risk Investment Icon Colored"
                  className="tile-icon hover"
                />
              </div>
            </div>
          </div>

          {/* Tile 4 */}
          <div className="expertise-item">
            <div className="expertise-content">
              <div className="expertise-text">
                <h3 className="expertise-title">
                  <span className="highlight-bg">
                    Asset & Wealth <br />
                    Growth
                  </span>
                </h3>
                <p className="expertise-description">
                  We help you with strategic investment solutions to grow
                  long-term wealth effortlessly.
                </p>

                <div className="learn-more">
                  <div className="circle-icon">
                    <svg viewBox="0 0 24 24" width="26" height="26">
                      <circle cx="12" cy="12" r="12" fill="#000" />
                      <g transform="rotate(135 12 12)">
                        <path
                          fill="#F96E2A"
                          d="M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z"
                        />
                      </g>
                    </svg>
                  </div>
                  <Link
                    to="/services#asset-wealth-growth"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <span className="learn-more-text">Learn more</span>
                  </Link>
                </div>

              </div>
              <div className="icon-wrapper">
                <img
                  src={require("../assets/services/candle_grey.webp")}
                  alt="Low Risk Investment Icon"
                  className="tile-icon default"
                />
                <img
                  src={require("../assets/services/candle_color.webp")}
                  alt="Low Risk Investment Icon Colored"
                  className="tile-icon hover"
                />
              </div>
            </div>
          </div>

          {/* Tile 5 */}
          <div className="expertise-item">
            <div className="expertise-content">
              <div className="expertise-text">
                <h3 className="expertise-title">
                  <span className="highlight-bg">
                    Tax & Estate <br /> Planning
                  </span>
                </h3>
                <p className="expertise-description">
                  Minimize your tax liabilities and maximize savings with our
                  experts
                </p>
                <div className="learn-more">
                  <div className="circle-icon">
                    <svg viewBox="0 0 24 24" width="26" height="26">
                      <circle cx="12" cy="12" r="12" fill="#000" />
                      <g transform="rotate(135 12 12)">
                        <path
                          fill="#F96E2A"
                          d="M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z"
                        />
                      </g>
                    </svg>
                  </div>
                  <Link
                    to="/services#tax-estate-planning"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <span className="learn-more-text">Learn more</span>
                  </Link>
                </div>
              </div>
              <div className="icon-wrapper">
                <img
                  src={require("../assets/services/glass_grey.webp")}
                  alt="Low Risk Investment Icon"
                  className="tile-icon default"
                />
                <img
                  src={require("../assets/services/glass_color.webp")}
                  alt="Low Risk Investment Icon Colored"
                  className="tile-icon hover"
                />
              </div>
            </div>
          </div>

          {/* Tile 6 */}
          <div className="expertise-item">
            <div className="expertise-content">
              <div className="expertise-text">
                <h3 className="expertise-title">
                  <span className="highlight-bg">
                    Low Risk <br />
                    Investments
                  </span>
                </h3>
                <p className="expertise-description">
                  Secure, low-risk options to preserve capital and generate
                  steady returns confidently.
                </p>

                <div className="learn-more">
                  <div className="circle-icon">
                    <svg viewBox="0 0 24 24" width="26" height="26">
                      <circle cx="12" cy="12" r="12" fill="#000" />
                      <g transform="rotate(135 12 12)">
                        <path
                          fill="#F96E2A"
                          d="M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z"
                        />
                      </g>
                    </svg>
                  </div>
                  <Link
                    to="/services#low-risk-investments"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <span className="learn-more-text">Learn more</span>
                  </Link>
                </div>

              </div>
              <div className="icon-wrapper">
                <img
                  src={require("../assets/services/dollar_grey.webp")}
                  alt="Low Risk Investment Icon"
                  className="tile-icon default"
                />
                <img
                  src={require("../assets/services/tick_colored.webp")}
                  alt="Low Risk Investment Icon Colored"
                  className="tile-icon hover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section
        className="vision-mission-hero"
        style={{
          backgroundImage: `url(${visionMissionBg})`,
        }}
      >
        <div className="vision-hero-inner">
          <div className="vision-part">
            <div className="vision-heading-row">
              <h1 className="vision-title">
                Our <span className="highlight-orange">Vision</span>
              </h1>
            </div>
            <div className="vision-text-row">
              <p className="vision-lead">
                To empower our clients to make informed decisions and achieve
                financial success while earning their trust and building
                long-lasting relationships.
              </p>
            </div>
          </div>
          <div className="mission-part">
            <div className="mission-heading-row">
              <h1 className="mission-title">Mission</h1>
            </div>
            <div className="mission-text-row">
              <p className="mission-lead">
                Through continuous learning, innovation, and a client-first
                approach, we aim to build lasting relationships founded on
                trust, ultimately guiding them toward financial success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="our-journey-section">
        <h2>Our Journey</h2>
        <div className="our-journey-svg">
          <img src={ourJourneySvg} alt="Our Journey" />
        </div>
      </section>

      {/* Client Testimonials */}
      <section className="testimonials-section">
        <h2 className="testimonials-title">Client Testimonials</h2>
        <p className="testimonials-subtitle">
          We are honored to partner with our clients on their wealth journeys
          helping them grow, protect, and preserve their legacies with
          confidence.
        </p>
        <div className="testimonials-list">
          {testimonials.map((testimonial, idx) => (
            <div className="testimonial-card" key={idx}>
              {/* <div className="testimonial-quote-mark">“</div> */}
              <p className="testimonial-quote">{testimonial.quote}</p>
              <div className="testimonial-author">
                <span className="testimonial-name">{testimonial.name}</span>
                <span className="testimonial-title">{testimonial.title}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* contact us form */}
      <Contactform />
    </main>
  );
}

export default Home;
